import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-remove-magazine-dialog',
  templateUrl: './remove-magazine-dialog.component.html',
  styleUrls: ['./remove-magazine-dialog.component.scss']
})
export class RemoveMagazineDialogComponent {

  constructor(
    public dialogRef: MatDialogRef<RemoveMagazineDialogComponent>,

    @Inject(MAT_DIALOG_DATA) public data: {
      id: string,
      name: string
    },
  ) {}

  onConfirm(id: string) {
    this.dialogRef.close({ id: id });
  }
}
